import {createAsyncAction, createStandardAction} from "typesafe-actions";
import { Language } from "../settings/Language";
import {BonusType, IPlayerState} from "./types";

export const addCoins = createStandardAction('@player/ADD_COINS')<number, string | undefined>();
export const addScore = createStandardAction('@player/ADD_SCORE')<number, string | undefined>();
export const addLives = createStandardAction('@player/ADD_LIVES')<number, string | undefined>();
export const addBonus = createStandardAction('@player/ADD_BONUS')<{ bonus: BonusType, count: number }, string | undefined>();

export const buyLives = createStandardAction('@player/BUY_LIVES')<number>();

export const incrementCompletedLevels = createStandardAction('@player/COMPLETE_LEVEL')();

export const toggleMusic = createStandardAction('@player/TOGGLE_MUSIC')();
export const toggleSounds = createStandardAction('@player/TOGGLE_SOUNDS')();

export const createShortcut = createAsyncAction(
    '@player/CREATE_SHORTCUT',
    '@player/CREATE_SHORTCUT',
    '@player/CREATE_SHORTCUT')<void, void, void>();

export const changeProfile = createAsyncAction(
    '@settings/CHANGE_PROFILE_REQUEST',
    '@settings/CHANGE_PROFILE_SUCCESS',
    '@settings/CHANGE_PROFILE_FAILURE')<{ name: string, picture: string, language: Language, locale: string }, { name: string, picture: string }, void>();

export function hasLives(player: IPlayerState) {
    return player.lives > 0;
}